<h2 class="panel-gruppe-tittel" data-testid="dashboardstatus-radtittel">
  {{ 'Mangler din stemme'|translate }}
  <button mat-icon-button type="button" (click)="lukk()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<div class="panel-skrollkontainer nga-fast" [style.max-height.px]="maksPopupHoeyde() - 40"><!-- -40 for å ta høyde for høyden til overliggende h2 -->
    @if (avstemningerBrukerIkkeHarStemtPaa().length === 0) {
      <div class="ingen-avstemninger" data-testid="ingenavstemninger-dine">
        {{ 'Du har besvart alle avstemningene'|translate }}
        <mat-icon>celebration</mat-icon>
      </div>
    } @else {
      @for (avstemningInfo of avstemningerBrukerIkkeHarStemtPaa(); track avstemningInfo.avstemning.id) {
        <avstemning-mangler-brukers-stemme [manglerStemmegivning]="avstemningInfo"/>
      }
    }
  @if (harSkrivetilgang()) {
    <h2 class="panel-gruppe-tittel" data-testid="dashboardstatus-radtittel">{{ 'Mangler andres stemmer'|translate }}</h2>
      @if (avstemningerAndreIkkeHarStemtPaa().length === 0) {
        <div class="ingen-avstemninger" data-testid="ingenavstemninger-andres">
          {{ 'Alle andre har besvart avstemningene'|translate }}
          <mat-icon>celebration</mat-icon>
        </div>
      } @else {
        @for (avstemningSomManglerStemmer of avstemningerAndreIkkeHarStemtPaa(); track avstemningSomManglerStemmer.moete.id) {
          <avstemning-mangler-andres-stemme [manglerStemmegivning]="avstemningSomManglerStemmer"/>
        }
      }
  }
</div>

